export default __webpack_public_path__ + "schedule-md.4af4727d.svg";